import React from "react"
import s from "./Loader.less"

const DotLoader = () => {
  return (
    <div className={s.dotLoader}>
      <span></span>
      <span></span>
      <span></span>
    </div>
  )
}

export default DotLoader
